import "./UpdateVisit.css";

import { useState, useContext, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import toast from "react-hot-toast";
import VisitTab from "../Create/VisitTab";

//Global state Access
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

import "bootstrap/dist/css/bootstrap.min.css";
import BackButton from "../../../components/Buttons/BackButton";

//Context import
import AuthContext from "../../../components/shared/Context";

const UpdateVisitChild = ({
  currentRecord,
  patientRecordId,
  patientProfileData,
}) => {
  return (
    <div className="patient-create">
      <FormElement
        currentRecord={currentRecord}
        patientRecordId={patientRecordId}
        patientProfileData={patientProfileData}
      />
    </div>
  );
};

const FormElement = ({
  currentRecord,
  patientRecordId,
  patientProfileData: initialPatientProfileData,
}) => {
  const { loggedInUserDetails, selectedPatientProfile } =
    useContext(AuthContext);
  moment.tz.setDefault("Asia/Kolkata");
  //Error Logging Service
  const [{ errorLogApi }] = useAtom(gbState);

  const [patientProfileData, setPatientProfileData] = useState(
    initialPatientProfileData
  );
  const [latestWHRecord, setLatestWHRecord] = useState();

  const visitTypeInput = useRef();
  const doctorInput = useRef();
  const visitDateInput = useRef();
  const visitReasonInput = useRef();
  const visitWeightInput = useRef();
  const visitHeightInput = useRef();
  const visitTypeInput1 = useRef();

  let navigate = useNavigate();

  const [doctors, setDoctors] = useState([]);
  let defaultDate = new Date();
  const [date, setDate] = useState(defaultDate);
  const [patientHomeTC, setPatientHomeTC] = useState("");
  defaultDate.setDate(defaultDate.getDate());

  const today = new Date();

  // Initialize formData from currentRecord
  const initializeFormData = () => {
    if (!currentRecord) return null;

    // Parse JSON strings
    let visitReason = null;
    let visitType = null;
    let travelMode = null;

    try {
      if (currentRecord.visit_reason) {
        visitReason = JSON.parse(currentRecord.visit_reason);
      }
    } catch (e) {
      console.error("Error parsing visit_reason:", e);
    }

    try {
      if (currentRecord.visit_type) {
        visitType = JSON.parse(currentRecord.visit_type);
      }
    } catch (e) {
      console.error("Error parsing visit_type:", e);
    }

    try {
      if (currentRecord.travel_mode) {
        travelMode = JSON.parse(currentRecord.travel_mode);
      }
    } catch (e) {
      console.error("Error parsing travel_mode:", e);
    }

    // Extract doctor_id from object if it's an object
    let doctorId = "";
    if (currentRecord.doctor_id) {
      doctorId =
        typeof currentRecord.doctor_id === "object"
          ? currentRecord.doctor_id._id
          : currentRecord.doctor_id;
    }

    // Convert date_of_visit to moment
    let visitDate = moment.utc(today, "YYYY-MM-DD").startOf("day");
    if (currentRecord.date_of_visit) {
      visitDate = moment
        .utc(currentRecord.date_of_visit, "YYYY-MM-DD")
        .startOf("day");
    }

    return {
      patientId: currentRecord.patientId,
      date_of_visit: visitDate,
      hospitalization: currentRecord.hospitalization ?? null,
      consultation: currentRecord.consultation ?? null,
      ward_clinic_opd_number: currentRecord.ward_clinic_opd_number || "",
      doctor_id: doctorId,
      visit_reason: currentRecord.visit_reason || null,
      visit_type: currentRecord.visit_type || null,
      reason_others: currentRecord.reason_others || "",
      weight: currentRecord.weight || null,
      height: currentRecord.height || null,
      liver: currentRecord.liver ?? null,
      spleen: currentRecord.spleen ?? null,
      stay_cost: currentRecord.stay_cost ?? null,
      food_cost: currentRecord.food_cost ?? null,
      wages_lost_by_parents: currentRecord.wages_lost_by_parents ?? null,
      school_absentism: currentRecord.school_absentism ?? null,
      travel_cost: currentRecord.travel_cost ?? null,
      other_direct_indirect_cost:
        currentRecord.other_direct_indirect_cost ?? null,
      hcp_indirect_cost: currentRecord.hcp_indirect_cost ?? null,
      hemoglobin_initial_hb: currentRecord.hemoglobin_initial_hb ?? null,
      hemoglobin_final_hb: currentRecord.hemoglobin_final_hb ?? null,
      pre_transfusion_hb: currentRecord.pre_transfusion_hb ?? null,
      post_transfusion_hb: currentRecord.post_transfusion_hb ?? null,
      transfusion_regimen: currentRecord.transfusion_regimen ?? null,
      external_visit: currentRecord.external_visit ?? false,
      travel_mode: currentRecord.travel_mode || null,
      payment_status: currentRecord.payment_status ?? null,
      transportation_support: currentRecord.transportation_support ?? null,
      travel_distance: currentRecord.travel_distance || null,
      treatment_center_id:
        currentRecord.treatment_center_id?._id || loggedInUserDetails.tc_id,
      tc_state: currentRecord.tc_state || loggedInUserDetails.state,
      createdBy: loggedInUserDetails._id,
    };
  };

  const [formData, setFormData] = useState(
    initializeFormData() || {
      patientId: "",
      date_of_visit: moment.utc(today, "YYYY-MM-DD").startOf("day"),
      hospitalization: null,
      consultation: null,
      ward_clinic_opd_number: "",
      doctor_id: "",
      visit_reason: null,
      visit_type: null,
      reason_others: "",
      weight: null,
      height: null,
      liver: null,
      spleen: null,
      stay_cost: null,
      food_cost: null,
      wages_lost_by_parents: null,
      school_absentism: null,
      travel_cost: null,
      other_direct_indirect_cost: null,
      hcp_indirect_cost: null,
      hemoglobin_initial_hb: null,
      hemoglobin_final_hb: null,
      pre_transfusion_hb: null,
      post_transfusion_hb: null,
      transfusion_regimen: null,
      external_visit: false,
      travel_mode: null,
      payment_status: null,
      transportation_support: null,
      travel_distance: null,
      treatment_center_id: loggedInUserDetails.tc_id,
      tc_state: loggedInUserDetails.state,
      createdBy: loggedInUserDetails._id,
    }
  );

  // Set patientHomeTC from initial patientProfileData if provided
  useEffect(() => {
    if (initialPatientProfileData?.treatment_center) {
      setPatientHomeTC(initialPatientProfileData.treatment_center);
    }
  }, [initialPatientProfileData]);

  // Load patient profile if not provided as prop
  useEffect(() => {
    const loadPatientProfile = () => {
      const patientId = patientRecordId || currentRecord?.patientId;
      if (!patientId || initialPatientProfileData) return; // Skip if already provided as prop or no patientId

      const userToken = localStorage.getItem("token");
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/patient/profile/${patientId}`,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
        .then((response) => {
          setPatientProfileData(response?.data?.patient);
          setPatientHomeTC(response?.data?.patient?.treatment_center);
        })
        .catch((error) => {
          errorLogApi(error, "UpdateVisitChild", "/update-visit/");
        });
    };

    loadPatientProfile();
  }, [patientRecordId, currentRecord?.patientId, initialPatientProfileData]);

  useEffect(() => {
    const config = {
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/user/doc/${loggedInUserDetails.tc_id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        const doctorsData = response.data.doctors;
        setDoctors(doctorsData);
      })
      .catch(function (error) {
        errorLogApi(error, "UpdateVisitChild", "/update-visit/");
      });
  }, []);

  useEffect(() => {
    const getLatestWeightHeight = () => {
      const patientId = patientRecordId || currentRecord?.patientId;
      if (!patientId) return;

      const userToken = localStorage.getItem("token");

      axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/visits/latest-weight/${patientId}`,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
        .then((response) => {
          if (response?.data?.latestRecord) {
            setLatestWHRecord(response?.data?.latestRecord);
          }
        })
        .catch((error) => {
          errorLogApi(error, "GetLatestWeight", "visits/latest-weight");
        });
    };

    getLatestWeightHeight();
  }, [patientRecordId, currentRecord?.patientId]);

  useEffect(() => {
    if (latestWHRecord && !formData.weight) {
      setFormData({
        ...formData,
        weight: latestWHRecord?.weight,
        height: latestWHRecord?.height,
      });
    }
  }, [latestWHRecord]);

  const handleVisitUpdate = (e) => {
    e.preventDefault();

    if (
      loggedInUserDetails.role === "ST_ADM_ACCESS" ||
      loggedInUserDetails.role === "FULL_ACCESS"
    ) {
      toast.error(
        "State Admin cannot update the Visit record, Kindly login as Doctor/Nurse/Deo"
      );
      return;
    }

    if (formData.date_of_visit === null) {
      visitDateInput.current.focus();
      toast.error("Please select visit Date");
      return;
    }

    if (formData.consultation === null) {
      visitTypeInput.current.focus();
      toast.error("Please select visit type");
      return;
    }

    if (formData.doctor_id === "") {
      doctorInput.current.focus();
      toast.error("Please select Doctor");
      return;
    }

    //visit_reason
    if (formData.visit_reason === "") {
      visitReasonInput.current.focus();
      toast.error("Please select Visit Reason");
      return;
    }

    //weight
    if (formData.weight === null) {
      visitWeightInput.current.focus();
      toast.error("Please Enter Weight");
      return;
    }
    //height
    if (formData.height === null) {
      visitHeightInput.current.focus();
      toast.error("Please enter Height");
      return;
    }

    let userToken = localStorage.getItem("token");
    console.log(formData);
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/visits/update/${currentRecord._id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };
    axios(config)
      .then(function (response) {
        toast.success("Visit Updated Successfully.");
        navigate(-1);
      })
      .catch(function (error) {
        toast.error(error.response?.data?.message || "Error updating visit");
        errorLogApi(error, "UpdateVisitChild", "/update-visit/");
      });
  };

  const checkNonNegative = [
    "stay_cost",
    "food_cost",
    "wages_lost_by_parents",
    "school_absentism",
    "travel_cost",
    "other_direct_indirect_cost",
    "hcp_indirect_cost",
    "weight",
    "height",
    "travel_distance",
  ];

  useEffect(() => {
    // Iterate over each field in checkNonNegative
    checkNonNegative.forEach((field) => {
      // Check if the field's value is less than 0
      if (formData[field] < 0) {
        // Update the specific field to null
        setFormData((prevFormData) => ({
          ...prevFormData,
          [field]: null,
        }));
      }
    });
  }, [formData]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    // Check if the field is in the checkNonNegative array and the value is non-negative
    if (
      checkNonNegative.includes(name) &&
      (value === "" || parseInt(value, 10) >= 0)
    ) {
      setFormData({
        ...formData,
        [name]: value,
        patientId: currentRecord?.patientId || formData.patientId,
      });
    } else if (!checkNonNegative.includes(name)) {
      // Update the state normally for fields not in the checkNonNegative array
      setFormData({
        ...formData,
        [name]: value,
        patientId: currentRecord?.patientId || formData.patientId,
      });
    }
  };

  const handleChange01 = ({ currentTarget: input }) => {
    if (checkNonNegative.includes(input.name) && input.value < 0) {
      toast.error("Please enter a non negative number!");
      return;
    }

    setFormData({
      ...formData,
      [input.name]: input.value,
      patientId: currentRecord?.patientId || formData.patientId,
    });
  };

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
      patientId: currentRecord?.patientId || formData.patientId,
    });
  };

  if (!currentRecord) {
    return <div className="newPatientForm">Loading...</div>;
  }

  return (
    <form className="newPatientForm1" onSubmit={(e) => handleVisitUpdate(e)}>
      <h2>Update Visit</h2>
      <div className="submitButton">
        <div className="patientUpdateButton">
          <Button variant="success" size="medium" type="submit">
            Update Visit
          </Button>
          &nbsp;&nbsp;
          <BackButton />
          &nbsp;&nbsp;
          <Button
            variant="secondary"
            size="medium"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>
      </div>
      {patientProfileData ? (
        <VisitTab
          visitTypeInput={visitTypeInput}
          visitDateInput={visitDateInput}
          visitReasonInput={visitReasonInput}
          visitWeightInput={visitWeightInput}
          visitHeightInput={visitHeightInput}
          visitTypeInput1={visitTypeInput1}
          doctorInput={doctorInput}
          handleChange={handleChange}
          dropDownChange={dropDownChange}
          loggedInUserDetails={loggedInUserDetails}
          formData={formData}
          setFormData={setFormData}
          doctors={doctors}
          patientHomeTC={patientHomeTC}
          selectedPatientProfile={patientProfileData}
        />
      ) : (
        <div className="newPatientForm"> Loading ...</div>
      )}
    </form>
  );
};

export default UpdateVisitChild;
